/*This class is used to submit a bid from client to server.*/
export class BidRequest{
    
    public auctionId!:number;
    public userId!:string;
    public scheduleSeqNo?:number;
    public bidAmount!:number;
    public directBid:boolean = false;
    public isBackup:boolean = false; //currently used only for backup BuyNow

    constructor(){
    }
}